import * as cssVariable from 'cssVariables';
import collectionItemStyles from '../collectionItemStyle';
import { Styles } from 'jss';

export default (theme: StyleTheme): Styles => ({
  viewHeader: {
    margin: '28px 0',
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    ...cssVariable.pageTitle,
  },
  closeButton: {
    background: 'transparent',
    border: 'none',
    padding: 10,
    margin: -10,
    color: cssVariable.blue500,
    cursor: 'pointer',
  },
  collectionViewWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  closeOverlay: {
    width: '100%',
    height: 60,
    position: 'fixed',
    top: 0,
    ...cssVariable.contentPadding({ smallScreen: true }),
    paddingBottom: 0,
    border: 'none',
    background: 'none',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  collectionView: {
    ...cssVariable.contentPadding({ smallScreen: true }),
    width: '100%',
    // Add padding so content is not underneath the ios action bar
    paddingBottom: '130px',
  },
  ...collectionItemStyles(theme),
});
